import { useCallback } from "react";

import { useMarketingCampaignFormModelContext } from "../../../../context";

export const useResourceAvailablePrice = () => {
	const { viewModel, onSetViewModel } = useMarketingCampaignFormModelContext();
	const { resourceAvailablePrice } = viewModel;

	const onSetResourceAvailablePriceAmount = useCallback(
		(input: number | undefined) => {
			onSetViewModel([
				{
					key: "resourceAvailablePrice",
					value: {
						...resourceAvailablePrice,
						amount: {
							isEdited: true,
							value: input!,
						},
					},
				},
			]);
		},
		[onSetViewModel, resourceAvailablePrice],
	);

	return {
		resourceAvailablePrice,
		onSetResourceAvailablePriceAmount,
	};
};
